module.exports = __webpack_public_path__ + "static/img/tabbt2024_1.347594b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt2024_1.png
// module id = rRFd
// module chunks = 1